import RedeemDealLink from './RedeemDealLink';
export default RedeemDealLink;